import { render } from "./BranchSelectionDialogContent.vue?vue&type=template&id=0dffb216&scoped=true"
import script from "./BranchSelectionDialogContent.vue?vue&type=script&lang=js"
export * from "./BranchSelectionDialogContent.vue?vue&type=script&lang=js"

import "./BranchSelectionDialogContent.vue?vue&type=style&index=0&id=0dffb216&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dffb216"]])

export default __exports__